import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  setUser,
  setToken,
  setSignUpNow,
  selectSignupNow,
} from "../../redux/features/appData";
import { setAxiosAuthToken } from "../../services/client";
import { apiGetUserByEmail, apiCreateUserWithWorkspace } from "../../services/UserService";
import { useAuth0 } from "@auth0/auth0-react";
import SignupWidget from "./SignupWidget";
import "./Signup.css";
import { useDispatch, useSelector } from "react-redux";
import config from "environment";
import { User } from "effno-core";
import { EFFNO_LOGO } from "../shared/media";

const authURL = config.redirect.replace("signup", "login") + "?error=oauth";

const createNewUser = async (user: any) => {
  console.log("[root/createNewUser] user: ", user);

  const { given_name, family_name, picture, email } = user;

  const newUser = (await apiCreateUserWithWorkspace(
    given_name,
    family_name,
    email,
    picture,
    null
  )) as User;

  console.log("[root/createNewUser] new user: ", newUser);

  return newUser;
};

export default function Signup() {
  const [headerText, setHeaderText] = useState<any>({
    title: "Sign Up.",
    subtitle: "It's free to start",
  });

  const signUpNow = useSelector(selectSignupNow);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { user, getAccessTokenSilently, logout } = useAuth0();

  const redirectUser = () => {
    // if (stashUrl) {
    //   // changed this to go to /recents and leave stashUrl for now
    //   // window.location.href = stashUrl;
    //   // dispatch(setStashUrl(undefined));
    //   navigate("/recents");
    // } else {
    //   navigate("/recordings");
    // }

    //navigate("/shares");
    window.location.href = config.clientUrl + config.defaultRoute;
  };

  useEffect(() => {
    (async () => {
      if (!user || !user.email) {
        return;
      }

      const accessToken = await getAccessTokenSilently();

      dispatch(setToken(accessToken));
      setAxiosAuthToken(accessToken);

      // is this a new user, lets handle that now
      if (signUpNow === true) {
        // is this user already signed up and they just hit the wrong button
        const loadedUser = await apiGetUserByEmail(user.email);

        console.log("loadedUser", loadedUser);

        // if we don't have a user, create one
        if (!loadedUser) {
          (async () => {
            const newUser = await createNewUser(user);
            dispatch(setSignUpNow(false));
            if (newUser) {
              dispatch(setUser(newUser));

              redirectUser();

              return;
            } else {
              // console.error("[root/useeffect] failed to create new user: ", user);
            }

            // something went wrong, bounce them out again
            console.error("[root/use effect] new user failed to create!");
            // navigate("/signup");
          })();

          return;
        }

        // we have the user, so just log the user in below
        dispatch(setUser(loadedUser));
        redirectUser();
        return;
      } else {
        const loadedUser = await apiGetUserByEmail(user.email);

        // if this user does not exist we need to bounce the user out as someone hit
        // login and picked a user that we don't have in the DB

        if (!loadedUser) {
          // need to clean up OAuth so the user can try again as this is likely
          // the reason they got here

          // cleanup auth
          logout({ logoutParams: { returnTo: authURL } });
          return;
        }

        dispatch(setUser(loadedUser));

        redirectUser();
      }
    })();
  }, [user]);

  return (
    <div className={config.theme} style={{ width: "100%", height: "100%" }}>
      <div id="signup">
        <div className="signup-header">
          <div 
            className="signup-header-logo"
            onClick={() => window.open("https://effno.co", "_blank")}
          >
            <img src={EFFNO_LOGO.REGULAR} />
          </div>
          <div className="signup-header-buttons">
            Or&nbsp;
            <button
              className="signup-header-button"
              onClick={() => {
                navigate("/login");
              }}>
              Sign In
            </button>
          </div>
        </div>
        <div className="signup-container">
          <div className="signup-title">
            <h1>
              {headerText.title}
              <br />
              {headerText.subtitle}
            </h1>
          </div>

          <SignupWidget />
        </div>
      </div>
    </div>
  );
}
